import Renderer from "@wielink/datatables/Renderers/Renderer";

class Connect extends Renderer {
	render() {
		return `
			<button data-dt-btn="connect" data-id="${this.row.id}" class="btn btn-sm btn-success" aria-label="Koppelen" title="Koppelen">
				<i class="bi bi-link-45deg"></i>
			</button>
		`
	}
}

export default Connect;